import React, { createContext, useContext, useState, useCallback } from 'react';

interface PageHeader {
  title: string;
  description?: string;
}

interface PageHeaderContextValue {
  header: PageHeader;
  setHeader: (header: PageHeader) => void;
}

const PageHeaderContext = createContext<PageHeaderContextValue>({
  header: { title: '', description: '' },
  setHeader: () => {},
});

export function PageHeaderProvider({ children }: { children: React.ReactNode }) {
  const [header, setHeaderState] = useState<PageHeader>({ title: '', description: '' });

  const setHeader = useCallback((h: PageHeader) => {
    setHeaderState(h);
  }, []);

  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  return useContext(PageHeaderContext);
}

/** Call this hook inside a page component to push its title/description to the navbar. */
export function useSetPageHeader(title: string, description?: string) {
  const { setHeader } = usePageHeader();
  React.useEffect(() => {
    setHeader({ title, description });
  }, [title, description, setHeader]);
}
